(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flour-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('flour-guide')) {
  class FlourGuide extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.roles = JSON.parse(this.querySelector('script[data-fg-roles]').textContent); } catch (e) { return; }
      this.table = this.querySelector('.fg-table');
      this.tbody = this.table.tBodies[0];
      this.card = this.querySelector('.fg-card');
      this.sheetMQ = matchMedia('(max-width: 700px), (hover: none)');
      this.sortCol = null;
      this.filterRating = null;

      const hint = this.querySelector('.fg-hint');
      if (hint && matchMedia('(hover: none)').matches) hint.textContent = hint.textContent.replace(/^Hover/, 'Tap');
      const cells = this.querySelectorAll('.fg-cell');
      cells.forEach((c, i) => { c.tabIndex = i === 0 ? 0 : -1; });
      this.bind();
    }

    bind() {
      const t = this.table;
      t.addEventListener('pointerover', e => {
        if (e.pointerType !== 'mouse') return;
        const cell = e.target.closest('.fg-cell');
        if (cell) this.activate(cell);
      });
      t.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') this.deactivate(); });
      t.addEventListener('click', e => {
        const cell = e.target.closest('.fg-cell');
        if (cell) { this.activate(cell, true); cell.focus({ preventScroll: true }); return; }
        const btn = e.target.closest('[data-sort]');
        if (btn) this.sortBy(+btn.dataset.sort);
      });
      t.addEventListener('focusin', e => { const c = e.target.closest('.fg-cell'); if (c) this.activate(c); });
      t.addEventListener('focusout', e => { if (!t.contains(e.relatedTarget)) this.deactivate(); });
      t.addEventListener('keydown', e => this.onKey(e));

      this.querySelector('.fg-card-close').addEventListener('click', () => this.deactivate());
      this._docDown = e => { if (this.sheetMQ.matches && this.active && !e.target.closest('.fg-cell, .fg-card')) this.deactivate(); };
      this._docKey = e => { if (e.key === 'Escape') this.deactivate(); };
      this._reposition = () => { if (this.active) this.place(this.active); };
      document.addEventListener('pointerdown', this._docDown);
      document.addEventListener('keydown', this._docKey);
      window.addEventListener('scroll', this._reposition, { passive: true });
      window.addEventListener('resize', this._reposition);
      this.querySelector('.fg-scroll').addEventListener('scroll', this._reposition, { passive: true });

      this.querySelectorAll('.fg-legbtn').forEach(b => {
        b.addEventListener('mouseenter', () => { if (this.filterRating == null) this.highlight(b.dataset.filter); });
        b.addEventListener('mouseleave', () => { if (this.filterRating == null) this.highlight(null); });
        b.addEventListener('click', () => {
          const r = b.dataset.filter;
          this.filterRating = this.filterRating === r ? null : r;
          this.querySelectorAll('.fg-legbtn').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.filter === this.filterRating)));
          this.highlight(this.filterRating);
        });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this._docDown);
      document.removeEventListener('keydown', this._docKey);
      window.removeEventListener('scroll', this._reposition);
      window.removeEventListener('resize', this._reposition);
      if (this.card) this.card.classList.remove('is-open');
    }

    highlight(r) {
      this.table.classList.toggle('is-filtering', r != null);
      this.querySelectorAll('.fg-cell').forEach(c => c.classList.toggle('is-match', c.dataset.rating === r));
    }

    activate(cell, fromTap) {
      if (this.active === cell) return;
      this.clearHot();
      this.active = cell;
      const tr = cell.closest('tr');
      const col = cell.dataset.col;
      const role = this.roles[cell.dataset.rating];
      const app = this.querySelector(`thead th[data-col="${col}"]`).dataset.label;
      if (!role) return;

      cell.classList.add('is-active');
      tr.classList.add('is-row-hot');
      this.querySelectorAll(`.fg-cell[data-col="${col}"]`).forEach(c => c.classList.add('is-col-hot'));
      this.querySelectorAll('.fg-cell').forEach(c => { c.tabIndex = c === cell ? 0 : -1; });

      const c = this.card;
      const b = document.createElement('b');
      b.style.color = tr.dataset.color;
      b.textContent = tr.dataset.name;
      const ctx = c.querySelector('.fg-card-ctx');
      ctx.replaceChildren(b, document.createTextNode(' for ' + app.toLowerCase().replace('/ ', '/')));
      c.querySelector('.fg-card-mark').innerHTML = cell.querySelector('.fg-mark').outerHTML;
      c.querySelector('h3').textContent = role.name;
      c.querySelector('.fg-card-desc').textContent = role.desc;
      c.querySelector('.fg-meter-fill').style.width = role.fill + '%';
      c.querySelector('.fg-meter-label').textContent = role.meter;
      c.classList.add('is-open');
      this.place(cell);

      if (fromTap && this.sheetMQ.matches) {
        requestAnimationFrame(() => {
          const overlap = cell.getBoundingClientRect().bottom - (window.innerHeight - c.offsetHeight) + 12;
          if (overlap > 0) window.scrollBy({ top: overlap, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      }
    }

    clearHot() {
      this.querySelectorAll('.is-active, .is-row-hot, .is-col-hot').forEach(el => el.classList.remove('is-active', 'is-row-hot', 'is-col-hot'));
    }

    deactivate() {
      this.clearHot();
      this.active = null;
      this.card.classList.remove('is-open');
    }

    place(cell) {
      if (this.sheetMQ.matches) return;
      const c = this.card, r = cell.getBoundingClientRect();
      const cw = c.offsetWidth, ch = c.offsetHeight, gap = 12, pad = 12;
      let side = 'top', top = r.top - ch - gap;
      if (top < pad) { side = 'bottom'; top = r.bottom + gap; }
      let left = r.left + r.width / 2 - cw / 2;
      left = Math.max(pad, Math.min(left, window.innerWidth - cw - pad));
      c.dataset.side = side;
      c.style.top = top + 'px';
      c.style.left = left + 'px';
      c.style.setProperty('--arrow-x', (r.left + r.width / 2 - left) + 'px');
    }

    onKey(e) {
      const cell = e.target.closest('.fg-cell');
      const m = { ArrowRight: [0, 1], ArrowLeft: [0, -1], ArrowDown: [1, 0], ArrowUp: [-1, 0] }[e.key];
      if (!cell || !m) return;
      e.preventDefault();
      const rows = [...this.tbody.rows];
      const tr = rows[rows.indexOf(cell.closest('tr')) + m[0]];
      if (!tr) return;
      const next = tr.querySelector(`.fg-cell[data-col="${+cell.dataset.col + m[1]}"]`);
      if (next) { next.focus(); next.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
    }

    sortBy(col) {
      this.deactivate();
      this.sortCol = this.sortCol === col ? null : col;
      this.querySelectorAll('thead th[data-col]').forEach(th => {
        if (+th.dataset.col === this.sortCol) th.setAttribute('aria-sort', 'descending');
        else th.removeAttribute('aria-sort');
      });
      const rows = [...this.tbody.rows];
      const before = new Map(rows.map(r => [r, r.getBoundingClientRect().top]));
      const score = r => +r.querySelector(`.fg-cell[data-col="${this.sortCol}"]`).dataset.rating;
      const sorted = rows.slice().sort((a, b) =>
        this.sortCol == null ? a.dataset.row - b.dataset.row : (score(b) - score(a) || a.dataset.row - b.dataset.row));
      sorted.forEach(r => this.tbody.appendChild(r));
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      sorted.forEach(r => {
        const dy = before.get(r) - r.getBoundingClientRect().top;
        if (dy) r.animate([{ transform: `translateY(${dy}px)` }, { transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.2,.8,.2,1)' });
      });
    }
  }
  customElements.define('flour-guide', FlourGuide);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
/*
 * Wait for div#order-slots to be available in the DOM, set checked = false for all radio inputs inside
 * Add disabled to the submit button inside the form#cart
 * If the user clicks any radio input inside div#order-slots, remove disabled from the submit button 
 * 
 * P.S. this functionality got broken, seemingly the event listener we were adding to the radio inputs 
 * got overwritten after the PickEasy app was updated to add it's own event listeners. As a result, 
 * I commented out the code that disables the checkout button.
 */

document.addEventListener('DOMContentLoaded', function() {
  const containerObserver = new MutationObserver((mutations, observer) => {
    const orderSlots = document.querySelector('div#order-slots');
    const submitButton = document.querySelector('button.cart__checkout-button[type="submit"]');

    if (orderSlots && submitButton) {
      observer.disconnect();

      let userSelected = false;
      const radioButtons = orderSlots.querySelectorAll('input[type="radio"]');

      //submitButton.disabled = true;

      //const enforceDisabled = new MutationObserver(() => {
      //  if (!userSelected && !submitButton.disabled) {
      //    submitButton.disabled = true;
      //  }
      //});

      // the following line replaces the commented out code above, which was leading to
      // the submit button ALWAYS being disabled, even after changing the inputs.
      // If the commented code above gets restored, remove this line
      submitButton.disabled = false;

      enforceDisabled.observe(submitButton, {
        attributes: true,
        attributeFilter: ['disabled']
      });

      radioButtons.forEach(radio => {
        // radio.checked = false; // Uncheck all radios on load
        radio.addEventListener('change', () => {
          userSelected = true;
          enforceDisabled.disconnect();
          submitButton.disabled = false;
        });
      });
    }
  });

  containerObserver.observe(document.body, { childList: true, subtree: true });
});

  } catch(e) { console.error(e); }
})();
})();
